import api from '@/api'
import endpoints from '@/api/endpoints'

const defaultQueryParams = () => ({
  data_providers: [ 'diffbot', 'nativo_advertiser' ],
  order_by: 'page_views',
  order_direction: 'desc',
  asset_metrics: [
    'pct_scroll_initiations',
    'scroll_initiations',
    'avg_scroll_depth',
    'page_views',
    'social_actions',
    'avg_active_time',
    'active_time',
    'conversions'
  ],
  query_metrics: [
    'pct_scroll_initiations',
    'scroll_initiations',
    'avg_scroll_depth',
    'page_views',
    'social_actions',
    'avg_active_time',
    'active_time',
    'conversions'
  ],
  distribution: 'all'
})

const defaultState = () => ({
  asset: null,
  filters: {
    metricDateStart: '-10000',
    metricDateEnd: '0'
  },
  properties: []
})

const mutations = {
  setAsset (state, data) { state.asset = data },
  setFilter (state, { key, value }) { state.filters[key] = value },
  setProperties (state, data) { state.properties = data }
}

const actions = {
  getAsset ({ commit, rootState, state }, { brandId, pageUrlId }) {
    const competitorIds = rootState.brand.settings.competitors
      .map(c => c.id)

    const params = Object.assign(defaultQueryParams(), {
      metric_date_range: {
        gte: state.filters.metricDateStart,
        lte: state.filters.metricDateEnd
      },
      brand_ids: [ brandId ].concat(competitorIds),
      page_url_ids: [ pageUrlId ]
    })

    return api.post(endpoints.search.search(), params)
      .then(resp => {
        commit('setAsset', resp.data.assets[0] || {})
      })
  },
  getProperties ({ commit }, brandId) {
    const params = { brand_id: brandId }

    return api.get(endpoints.properties.list(), { params })
      .then(resp => {
        commit('setProperties', resp.data)
      })
  }
}

const getters = {}

export default {
  state: defaultState(),
  mutations,
  actions,
  getters,
  namespaced: true
}
